// extracted by mini-css-extract-plugin
module.exports = {"container":"VB-z","productName":"WB-z","modal":"XB-z","dimensions":"YB-z","recipientEmail":"ZB-z","lowStock":"_B-z","recommendedFit":"aC-z"};